<template>
  <v-bottom-sheet v-model="model" inset>
    <v-card class="text-center pa-4 pb-2">
      <v-card-title class="text-h6" style="text-transform:capitalize;">
        {{ bottomSheetStore.formTitle }}
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancel">Cancelar</v-btn>
        <v-btn color="error" @click="confirm">Confirmar</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>

<script setup lang="ts">
import { useBottomSheetStore } from '@/store/bottomSheet';
import { computed } from 'vue'
const bottomSheetStore = useBottomSheetStore();

const model = computed({
  get: () => bottomSheetStore.isOpen,
  set: (val) => {
    if (!val) bottomSheetStore.closeSheet();
  }
});

const cancel = () => {
  bottomSheetStore.closeSheet();
};

const confirm = async () => {
  const { action, item } = bottomSheetStore.props || {};
  if (action && item) {
    try {
      await action(item);
    } catch (e) {
      console.error('Error ejecutando acción en BottomSheet:', e);
    }
  }
  bottomSheetStore.closeSheet();
};
</script>
